import { CardTheme } from "../types";
// Import image as module - webpack will optimize and provide the correct path
import noiseImage from "./card-bg/noise.png";

// Base theme configuration
const baseTheme: Omit<CardTheme, "background"> = {
  colors: {
    red: "#E53935",
    blue: "#1E88E5",
    green: "#43A047",
    yellow: "#FDD835",
    wild: "#111111",
  },
  card: {
    width: 300,
    height: 420,
    radius: 24,
    ovalColor: "#FFFFFF",
  },
  symbol: {
    color: "#000000",
  },
};

// Helper function to create theme with different background types
export function createClassicTheme(useImageBackground: boolean = false): CardTheme {
  return {
    ...baseTheme,
    background: useImageBackground
        ? {
            type: "image",
            image: {
              src: noiseImage,
              opacity: 0.25, // Increased opacity for better visibility
              scale: 1,
            },
          }
      : {
          type: "color",
        },
  };
}

// Default export - change `true` to `false` to use color background
export const ClassicTheme: CardTheme = createClassicTheme(true);
